// @ts-nocheck
import styled from "@emotion/styled";

export const Wrap = styled("div")`
  ${({ background, theme, checked, disabled, color, validate }) => `
    display: flex;
    align-items: center;
    cursor: pointer;

    svg {
      min-width: 16px;
      min-height: 16px;
      fill: ${checked ? theme.colors[color] : theme.colors.gray};
      ${disabled ? `fill: ${theme.colors.gray300}` : ""};
      ${validate ? `fill: ${theme.colors.danger}` : ""};
    }
    
    ${
      background && !disabled
        ? `
      justify-content: center;
      transition: all 0.3s ease;
      width: 28px;
      height: 28px;
      border-radius: ${theme.borderRadius.md};

      &:hover {
        background-color: ${theme.colors.gray300};

        svg {
          ${!checked ? `fill: ${theme.colors.gray900};` : ""}
        }
      }
    `
        : ""
    }
  `}
`;
